module.exports = __webpack_public_path__ + "img/user.896129ac.svg";